module.exports = __webpack_public_path__ + "img/timer-icon.a4c6e375.svg";